module.exports = __webpack_public_path__ + "static/media/pos.a537e027.png";